var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.propSelectValues != null
    ? _c("div", { staticClass: "input-unit mb-4" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selectionRelationId,
                expression: "selectionRelationId"
              }
            ],
            staticClass: "custom-select",
            on: {
              change: [
                function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selectionRelationId = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
                function($event) {
                  return _vm.changeBranche()
                }
              ]
            }
          },
          [
            _vm.selectionRelationId == 0
              ? _c("option", { attrs: { value: "0" } }, [
                  _vm._v(
                    _vm._s(_vm.$translate("Woerner::Template.chooseBranche"))
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.propSelectValues, function(option) {
              return _c("option", { domProps: { value: option.id } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(option.relation.relationValues[0].value) +
                    "\n        "
                )
              ])
            })
          ],
          2
        ),
        _vm._v(" "),
        _vm.currentuserpropname != null
          ? _c("label", [
              _vm._v("\n        " + _vm._s(_vm.currentuserpropname) + "\n    ")
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }